import { createContext, useContext } from 'react';

export const translations = {
  ru: {
    kanbanBoard: 'Канбан‑доска',
    loginTitle: 'Вход',
    loginLabel: 'Логин:',
    loginPlaceholder: 'Введите логин или почту',
    passwordLabel: 'Пароль:',
    passwordPlaceholder: 'Введите ваш пароль',
    signIn: 'Войти',
    register: 'Зарегистрироваться',
    registerTitle: 'Регистрация',
    firstName: 'Имя:',
    lastName: 'Фамилия:',
    email: 'Почта:',
    favColor: 'Любимый цвет:',
    password: 'Пароль:',
    repeatPassword: 'Повторите пароль:',
    agree: 'Я даю согласие на обработку персональных данных в соответствии с',
    law152: 'Федеральным законом № 152‑ФЗ',
    myProfile: 'Мой профиль',
    activeTasks: 'Активные задачи',
    finishedTasks: 'Завершенные задачи',
    noPage: 'Страница не найдена',
    tasksEmpty: 'нет задач',
    addCard: 'добавить карточку',
    login: 'Логин',
    taskTitlePlaceholder: 'Название задачи',
    descriptionPlaceholder: 'Описание',
    add: 'Добавить',
    selectTask: 'выберите задачу',
    back: 'Назад',
    columns: { Backlog: 'Задачи', Ready: 'Выполнить', 'In Progress': 'В работе', Finished: 'Завершенные' },
    menu: { profile: 'Мой профиль', tasks: 'Мои задачи', logout: 'Выйти' },
    // auth/register messages
    registerSuccess: 'Регистрация выполнена. Перенаправляем на страницу входа...',
    needRegisterFirst: 'Сначала зарегистрируйтесь',
    invalidCredentials: 'Неверный логин или пароль',
    userDataCorrupted: 'Данные пользователя повреждены. Зарегистрируйтесь заново.',
    mustFillAll: 'Заполните все обязательные поля',
    mustAgree: 'Необходимо согласие на обработку персональных данных',
    invalidEmail: 'Некорректная почта',
    passwordTooShort: 'Пароль должен быть не короче 6 символов',
    passwordsMismatch: 'Пароли не совпадают',
  },
  en: {
    kanbanBoard: 'Kanban Board',
    loginTitle: 'Login',
    loginLabel: 'Login:',
    loginPlaceholder: 'Enter username or email',
    passwordLabel: 'Password:',
    passwordPlaceholder: 'Enter your password',
    signIn: 'Sign in',
    register: 'Register',
    registerTitle: 'Registration',
    firstName: 'First name:',
    lastName: 'Last name:',
    email: 'Email:',
    favColor: 'Favorite color:',
    password: 'Password:',
    repeatPassword: 'Repeat password:',
    agree: 'I agree to the processing of personal data in accordance with',
    law152: 'Federal Law No. 152‑FZ',
    myProfile: 'My profile',
    activeTasks: 'Active tasks',
    finishedTasks: 'Finished tasks',
    noPage: 'Page not found',
    tasksEmpty: 'no tasks',
    addCard: 'add card',
    login: 'login',
    taskTitlePlaceholder: 'Task title',
    descriptionPlaceholder: 'Description',
    add: 'Add',
    selectTask: 'select a task',
    back: 'Back',
    columns: { Backlog: 'Backlog', Ready: 'Ready', 'In Progress': 'In Progress', Finished: 'Finished' },
    menu: { profile: 'My account', tasks: 'My tasks', logout: 'Log Out' },
    // auth/register messages
    registerSuccess: 'Registration completed. Redirecting to sign-in...',
    needRegisterFirst: 'Please register first',
    invalidCredentials: 'Invalid username or password',
    userDataCorrupted: 'User data is corrupted. Please register again.',
    mustFillAll: 'Fill in all required fields',
    mustAgree: 'Consent to personal data processing is required',
    invalidEmail: 'Invalid email',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordsMismatch: 'Passwords do not match',
  },
};

export const I18nContext = createContext({ lang: 'ru', t: (k) => k });

export const useT = () => useContext(I18nContext).t;
